import { render, staticRenderFns } from "./ci_resource_details.vue?vue&type=template&id=a1c338ee&vue3"
import script from "./ci_resource_details.vue?vue&type=script&lang=js&vue3"
export * from "./ci_resource_details.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports